<template>
	<div>
		<div class="row menuAriane">
			<div @click="clickOnArianneCategory()" class="menuArianeCategory" v-if="activeCategory">
				<span class="menuArianeValue">{{ activeCategory.key }}</span> <i class="icon-x"></i>
			</div>
			<div @click="clickOnArianneSubcategory()" class="menuArianeSubcategory" v-if="activeSubcategory">
				<span class="menuArianeValue">{{ activeSubcategory.key }}</span> <i class="icon-x"></i>
			</div>
			<div @click="clickOnArianneMastertag()" class="menuArianeMastertag" v-if="activeMastertag">
				<span class="menuArianeValue">{{ activeMastertag.key }}</span> <i class="icon-x"></i>
			</div>
			<div @click="clickOnArianneTrend()" class="menuArianeTrend" v-if="activeTrend">
				<span class="menuArianeValue">{{ activeTrend.key }}</span> <i class="icon-x"></i>
			</div>
		</div>
		<transition name="slide">
			<div class="row menuCategory" v-show="show && showlistcategory">
				<listcategory
					v-if="request === 'tag' && displayCat"
					ref="categoryList"
					class="categoryList"
					@clickoncategory="clickOnCategory($event)"
					title="Categories"
					object="category"
					:request="request"
					:first="request === 'tag' ? true : false"
					:filters="filters"
					:columns="nbColumns"
				></listcategory>
				<listcategory
					v-if="displaySubCat"
					ref="subcategoryList"
					class="subcategoryList"
					@clickoncategory="clickOnSubcategory($event)"
					:title="request === 'tag' ? 'Sub-categories' : 'Categories'"
					object="subcategory"
					:request="request"
					:first="request != 'tag' ? true : false"
					:color="activeCategory ? 'red' : null"
					:filters="filters"
					:columns="nbColumns"
				></listcategory>
				<listcategory
					v-if="displayTopics"
					ref="mastertagList"
					class="mastertagList"
					@clickoncategory="clickOnMastertag($event)"
					:title="mastertagTitle"
					object="mastertag"
					:request="request"
					:color="activeSubcategory ? 'blue' : activeCategory ? 'red' : null"
					:filters="filters"
					:columns="nbColumns"
				></listcategory>
				<listcategory
					v-if="displayTrends"
					ref="trendList"
					class="trendList"
					@clickoncategory="clickOnTrend($event)"
					title="Trends"
					object="trend"
					:request="request"
					:color="activeSubcategory ? 'blue' : activeCategory ? 'red' : null"
					:filters="filters"
					:columns="nbColumns"
				></listcategory>
			</div>
		</transition>
		<div v-if="show && showlistcategory" @click="show = !show" class="row menuCategoryButton">
			<i class="fas fa-chevron-up active" style="padding-top: 5px"></i>
		</div>
		<div v-else @click="show = !show" class="row menuCategoryButton">
			<i class="fas fa-chevron-down" style="padding-top: 5px"></i>
		</div>
	</div>
</template>

<script>
import listcategory from "@/components/globalVue/ListCategory.vue";
export default {
	name: "ListCategories",
	props: {
		request: {
			type: String,
			default: "",
		},
		filters: {
			type: Object,
			default: function () {
				return {};
			},
		},
		showlistcategory: {
			type: Boolean,
			default: true,
		},
	},
	emits: ["removeBrands", "changetitle", "changeListCat", "filters"],
	data() {
		return {
			localFilters: {},
			loading: true,
			activeCategory: null,
			activeSubcategory: null,
			activeMastertag: null,
			activeTrend: null,
			show: true,
			type: "",
			order: 0,
			displayCat: true,
			displaySubCat: true,
			displayTopics: true,
			displayTrends: true,
		};
	},
	components: {
		listcategory: listcategory,
	},
	mounted() {
		this.localFilters = this.filters;
	},
	methods: {
		// The three lists only
		reloadAll(p, reset = false) {
			if (this.$refs.categoryList) {
				this.$refs.categoryList.removeActiveCategory();
			}
			if (this.$refs.subcategoryList) {
				this.$refs.subcategoryList.removeActiveCategory();
			}
			if (this.$refs.mastertagList) {
				this.$refs.mastertagList.removeActiveCategory();
			}
			if (this.$refs.trendList) {
				this.$refs.trendList.removeActiveCategory();
			}

			if (p.category == "" && p.subcategory == "" && p.mastertag == "" && p.trend == "" && reset == false) {
				this.activeCategory = null;
				this.activeSubcategory = null;
				this.activeMastertag = null;
				this.activeTrend = null;
				if (this.$refs.categoryList) {
					this.$refs.categoryList.loadComponent(p);
				}
				if (this.$refs.subcategoryList) {
					this.$refs.subcategoryList.loadComponent(p);
				}
				if (this.$refs.mastertagList) {
					this.$refs.mastertagList.loadComponent(p);
				}
				if (this.$refs.trendList) {
					this.$refs.trendList.loadComponent(p);
				}
			} else if (p.category != "") {
				if (this.$refs.subcategoryList) {
					this.$refs.subcategoryList.loadComponent(p);
				}
				if (this.$refs.mastertagList) {
					this.$refs.mastertagList.loadComponent(p);
				}
				if (this.$refs.trendList) {
					this.$refs.trendList.loadComponent(p);
				}
				this.activeCategory = {};
				this.activeCategory.key = p.category;
			} else if (p.subcategory != "") {
				if (this.$refs.mastertagList) {
					this.$refs.mastertagList.loadComponent(p);
				}
				if (this.$refs.trendList) {
					this.$refs.trendList.loadComponent(p);
				}

				this.activeSubcategory = {};
				this.activeSubcategory.key = p.subcategory;
			} else if (p.mastertag != "") {
				if (this.$refs.trendList) {
					this.$refs.trendList.loadComponent(p);
				}
				this.activeMastertag = {};
				this.activeMastertag.key = p.mastertag;
			} else if (p.trend != "") {
				this.activeTrend = {};
				this.activeTrend.key = p.trend;
			}

			if (reset == true) {
				this.activeCategory = null;
				this.activeSubcategory = null;
				this.activeMastertag = null;
				this.activeTrend = null;
				if (this.$refs.categoryList) {
					this.$refs.categoryList.loadComponent(p);
				}
				if (this.$refs.subcategoryList) {
					this.$refs.subcategoryList.loadComponent(p);
				}
				if (this.$refs.mastertagList) {
					this.$refs.mastertagList.loadComponent(p);
				}
				if (this.$refs.trendList) {
					this.$refs.trendList.loadComponent(p);
				}
			}
		},
		reloadListCategory(object) {
			let p = JSON.parse(JSON.stringify(this.localFilters));
			if (object === "category") {
				// console.log(object)
				// store.dispatch('removeFromParameters', "mastertag")
				// store.dispatch('removeFromParameters', "subcategory")
				// let p ={...this.localFilters}
				p.mastertag = "";
				p.subcategory = "";
				// let p = store.getters.parameters
				if (this.activeCategory !== null) {
					p.category = this.activeCategory.key;
				}

				if (this.activeSubcategory !== null) {
					p.subcategory = this.activeSubcategory.key;
				}
				if (this.activeMastertag !== null) {
					p.mastertag = this.activeMastertag.key;
				}
				if (this.activeTrend !== null) {
					p.trend = this.activeTrend.key;
				}
				// console.log(p)

				if (this.$refs.subcategoryList) {
					this.$refs.subcategoryList.removeActiveCategory();
					this.$refs.subcategoryList.loadComponent(p);
				}
				if (this.$refs.mastertagList) {
					this.$refs.mastertagList.removeActiveCategory();
					this.$refs.mastertagList.loadComponent(p);
				}
				if (this.$refs.trendList) {
					this.$refs.trendList.removeActiveCategory();
					this.$refs.trendList.loadComponent(p);
				}
			}
			if (object === "subcategory") {
				// store.dispatch('removeFromParameters', "mastertag")
				// let p = store.getters.parameters
				// let p ={...this.localFilters}

				p.mastertag = "";

				if (this.activeCategory !== null) {
					p.category = this.activeCategory.key;
				}

				if (this.activeSubcategory !== null) {
					p.subcategory = this.activeSubcategory.key;
				}
				if (this.activeMastertag !== null) {
					p.mastertag = this.activeMastertag.key;
				}
				if (this.activeTrend !== null) {
					p.trend = this.activeTrend.key;
				}

				if (this.$refs.mastertagList) {
					this.$refs.mastertagList.removeActiveCategory();
					this.$refs.mastertagList.loadComponent(postMessage);
				}
				if (this.$refs.trendList) {
					this.$refs.trendList.removeActiveCategory();
					this.$refs.trendList.loadComponent(p);
				}
			}
			if (object === "mastertag") {
				// let p = store.getters.parameters
				// let p ={...this.localFilters}
				if (this.activeCategory !== null) {
					p.category = this.activeCategory.key;
				}

				if (this.activeSubcategory !== null) {
					p.subcategory = this.activeSubcategory.key;
				}
				if (this.activeMastertag !== null) {
					p.mastertag = this.activeMastertag.key;
				}
				if (this.activeTrend !== null) {
					p.trend = this.activeTrend.key;
				}

				if (this.$refs.trendList) {
					this.$refs.trendList.removeActiveCategory();
					this.$refs.trendList.loadComponent(p);
				}
			}
			if (object === "trend") {
				// let p = store.getters.parameters
				// let p ={...this.localFilters}
				if (this.activeCategory !== null) {
					p.category = this.activeCategory.key;
				}

				if (this.activeSubcategory !== null) {
					p.subcategory = this.activeSubcategory.key;
				}
				if (this.activeMastertag !== null) {
					p.mastertag = this.activeMastertag.key;
				}
				if (this.activeTrend !== null) {
					p.trend = this.activeTrend.key;
				}
			}
			this.$emit("filters", this.localFilters);
		},
		// The whole page
		reloadFromClick(object, label) {
			// let p ={...this.localFilters}
			this.localFilters[object] = label;
			// store.dispatch('addToParameters', {key: object, value: label})
			// store.dispatch('addToParameters', {key: "type", value: "Posts"})
		},
		clickOnCategory(event) {
			if (this.activeCategory !== event) {
				this.activeSubcategory = null;
				this.activeMastertag = null;
				this.activeTrend = null;
				this.activeCategory = event;

				this.reloadFromClick("category", event.key);
				this.reloadListCategory("category");
			}
		},
		clickOnSubcategory(event) {
			if (this.activeSubcategory !== event) {
				this.activeMastertag = null;
				this.activeTrend = null;
				this.activeSubcategory = event;
				this.reloadFromClick("subcategory", event.key);
				this.reloadListCategory("subcategory");
			}
		},
		clickOnMastertag(event) {
			if (this.activeMastertag !== event) {
				this.activeTrend = null;
				this.activeMastertag = event;
				this.reloadFromClick("mastertag", event.key);
				this.reloadListCategory("mastertag");
			}
		},
		clickOnTrend(event) {
			if (this.activeTrend !== event) {
				this.activeTrend = event;
				this.reloadFromClick("trend", event.key);
				this.reloadListCategory("trend");
			}
		},
		clickOnArianneCategory() {
			// let p ={...this.localFilters}
			console.log("click on cat");
			if (this.activeCategory.key === "Brands") {
				this.$emit("removeBrands");
			}

			this.activeCategory = null;
			this.activeSubcategory = null;
			this.activeMastertag = null;
			this.activeTrend = null;

			if (this.$refs.categoryList) {
				this.$refs.categoryList.removeActiveCategory();
			}
			if (this.$refs.subcategoryList) {
				this.$refs.subcategoryList.removeActiveCategory();
			}
			if (this.$refs.mastertagList) {
				this.$refs.mastertagList.removeActiveCategory();
			}
			if (this.$refs.trendList) {
				this.$refs.trendList.removeActiveCategory();
			}

			// WARNING Unexpected mutation of "filters" prop
			this.localFilters.mastertag = "";
			this.localFilters.subcategory = "";
			this.localFilters.category = "";
			this.localFilters.trend = "";
			console.log(this.activeCategory);
			this.$emit("changeListCat", {
				showlist: this.activeCategory == null ? true : false,
				val: {
					mastertag: this.activeMastertag,
					subcategory: this.activeSubcategory,
					category: this.activeCategory,
					trend: this.activeTrend,
				},
			});

			// store.dispatch('removeFromParameters', "mastertag")
			// store.dispatch('removeFromParameters', "subcategory")
			// store.dispatch('removeFromParameters', "category")
			// this.checkFilter()
			this.reloadListCategory("category");
		},
		clickOnArianneSubcategory() {
			console.log("click on subcat");
			// let p ={...this.localFilters}
			this.activeSubcategory = null;
			this.activeMastertag = null;
			this.activeTrend = null;

			if (this.$refs.subcategoryList) {
				this.$refs.subcategoryList.removeActiveCategory();
			}
			if (this.$refs.mastertagList) {
				this.$refs.mastertagList.removeActiveCategory();
			}
			if (this.$refs.trendList) {
				this.$refs.trendList.removeActiveCategory();
			}

			// WARNING Unexpected mutation of "filters" prop
			//this.localFilters.mastertag = "";
			//this.localFilters.subcategory = "";
			this.$emit("changeListCat", {
				showlist: this.activeSubcategory == null && this.activeCategory == null ? true : false,
				val: {
					mastertag: this.activeMastertag,
					subcategory: this.activeSubcategory,
					category: this.activeCategory,
					trend: this.activeTrend,
				},
			});
			// this.checkFilter()
			// store.dispatch('removeFromParameters', "mastertag")
			// store.dispatch('removeFromParameters', "subcategory")
			this.reloadListCategory("subcategory");
		},
		clickOnArianneMastertag() {
			// let p ={...this.localFilters}
			console.log("click on mt");
			this.activeMastertag = null;
			this.activeTrend = null;

			if (this.$refs.mastertagList) {
				this.$refs.mastertagList.removeActiveCategory();
			}
			if (this.$refs.trendList) {
				this.$refs.trendList.removeActiveCategory();
			}
			this.localFilters.mastertag = "";
			console.log(this.activeMastertag);
			this.$emit("changeListCat", {
				showlist: this.activeMastertag == null && this.activeSubcategory == null && this.activeCategory == null ? true : false,
				val: {
					mastertag: this.activeMastertag,
					subcategory: this.activeSubcategory,
					category: this.activeCategory,
					trend: this.activeTrend,
				},
			});
			// this.checkFilter()
			// store.dispatch('removeFromParameters', "mastertag")
			// this.reloadListCategory("mastertag");
		},
		clickOnArianneTrend() {
			// let p ={...this.localFilters}
			this.activeTrend = null;

			if (this.$refs.trendList) {
				this.$refs.trendList.removeActiveCategory();
			}

			this.localFilters.trend = "";
			this.$emit("changeListCat", {
				showlist:
					this.activeTrend == null &&
					this.activeMastertag == null &&
					this.activeSubcategory == null &&
					this.activeCategory == null
						? true
						: false,
				val: {
					mastertag: this.activeMastertag,
					subcategory: this.activeSubcategory,
					category: this.activeCategory,
					trend: this.activeTrend,
				},
			});
			// this.reloadListCategory("trend");
			// this.checkFilter()
			// store.dispatch('removeFromParameters', "mastertag")
		},
		changeTitleTopicsBrandsPeople(title) {
			this.$emit("changetitle", title);
		},
	},
	computed: {
		mastertagTitle() {
			if (this.request === "people") {
				return "People";
			} else if (this.request === "brand") {
				return "Brands";
			} else {
				return "Topics";
			}
		},
		nbColumns() {
			return [this.displayCat, this.displaySubCat, this.displayTopics, this.displayTrends].filter(Boolean).length;
		},
	},
	watch: {
		"localFilters.typemastertag"(newVal) {
			this.displayCat = true;
			this.displaySubCat = true;
			this.displayTopics = true;
			this.displayTrends = true;
			if (newVal === "brand") {
				this.displayTrends = false;
				this.displayCat = false;
			} else if (newVal === "tag") {
				this.displayTrends = false;
			} else if (newVal === "trends") {
				this.displaySubCat = false;
				this.displayTopics = false;
			}
		},
		"$store.getters.parameters": function (newValue, oldValue) {
			function compareTwoArrays(array1, array2) {
				let sameArrays = [];
				if (array1.length !== array2.length) {
					return false;
				}
				if (array1) {
					sameArrays = array1.every(function (e, i) {
						return e === array2[i];
					});
				}

				return sameArrays;
			}

			// this.type = store.getters.parameters.tagclass
			// let p ={...this.localFilters}
			this.type = this.localFilters.typemastertag;
			newValue = newValue ? newValue : null;
			oldValue = oldValue ? oldValue : null;

			let reload = false;
			if (!oldValue) {
				reload = true;
			} else {
				if (newValue.date.gte !== oldValue.date.gte) {
					reload = true;
				}
				if (newValue.date.lte !== oldValue.date.lte) {
					reload = true;
				}

				// 8 lines below : Only for the first connection
				let newGender = typeof newValue.gender !== "undefined" ? newValue.gender : [];
				let oldGender = typeof oldValue.gender !== "undefined" ? oldValue.gender : [];
				let newAge = typeof newValue.age !== "undefined" ? newValue.age : [];
				let oldAge = typeof oldValue.age !== "undefined" ? oldValue.age : [];
				let newCountry = typeof newValue.country !== "undefined" ? newValue.country : [];
				let oldCountry = typeof oldValue.country !== "undefined" ? oldValue.country : [];
				let newSources = typeof newValue.sources !== "undefined" ? newValue.sources : [];
				let oldSources = typeof oldValue.sources !== "undefined" ? oldValue.sources : [];

				let gender = compareTwoArrays(newGender, oldGender);
				let age = compareTwoArrays(newAge, oldAge);
				let country = compareTwoArrays(newCountry, oldCountry);
				let sources = compareTwoArrays(newSources, oldSources);

				if (!gender || !age || !country || !sources) reload = true;
			}

			if (reload === true) {
				// let p ={...this.localFilters}
				let tmpSubcat = this.localFilters.subcategory;
				let tmpMastertag = this.localFilters.mastertag;
				this.localFilters.mastertag = "";
				// store.dispatch('removeFromParameters', "mastertag")

				// let p = store.getters.parameters
				this.activeCategory !== null ? (this.localFilters.category = this.activeCategory.key) : false;
				this.activeSubcategory !== null ? (this.localFilters.subcategory = this.activeSubcategory.key) : false;

				if (this.$refs.subcategoryList) {
					this.$refs.subcategoryList.loadComponent(this.localFilters);
				}
				if (this.$refs.mastertagList) {
					this.$refs.mastertagList.loadComponent(this.localFilters);
				}
				if (this.$refs.trendList) {
					this.$refs.trendList.loadComponent(this.localFilters);
				}

				if (this.$props.request === "tag") {
					// store.dispatch('removeFromParameters', "subcategory")
					// let p = store.getters.parameters
					// let p ={...this.localFilters}
					this.localFilters.subcategory = "";
					this.activeCategory !== null ? (this.localFilters.category = this.activeCategory.key) : false;

					if (this.$refs.categoryList) {
						this.$refs.categoryList.loadComponent(this.localFilters);
					}
				}

				// typeof tmpSubcat !== 'undefined' ? store.dispatch('addToParameters', {key: 'subcategory', value: tmpSubcat}) : false;
				// typeof tmpMastertag !== 'undefined' ? store.dispatch('addToParameters', {key: 'mastertag', value: tmpMastertag}) : false;
				typeof tmpSubcat !== "undefined" ? (this.localFilters.subcategory = tmpSubcat) : false;
				typeof tmpMastertag !== "undefined" ? (this.localFilters.mastertag = tmpMastertag) : false;
			}
		},
	},
};
</script>

<style>
.menuAriane {
	display: flex;
	align-items: center;
	height: 30px;
	padding: 0px 20px;
	margin: -20px -20px 0px -20px;
	background-color: #fff;
	border-bottom: 1px solid #e5e5e5;
}

.menuAriane > div {
	display: flex;
	align-items: center;
	height: 20px;
	min-width: 150px;
	padding: 0px 4px 0px 7px;
	margin-right: 10px;
	border-radius: 12px;
	font-size: 13px;
	font-weight: 700;
	text-transform: uppercase;
	cursor: pointer;
}

.menuAriane > div i {
	font-size: 6px;
	padding: 4px;
	margin-left: auto;
	border-radius: 50%;
}

.menuArianeValue {
	margin-right: 20px;
}

.menuArianeCategory {
	color: #ef402e;
	border: 1px solid #ef402e;
}

.menuArianeCategory i {
	color: #fff;
	background-color: #ef402e;
}

.menuArianeSubcategory {
	color: #33d1cd;
	border: 1px solid #33d1cd;
}

.menuArianeSubcategory i {
	color: #fff;
	background-color: #33d1cd;
}

.menuArianeMastertag {
	color: #23056b;
	border: 1px solid #23056b;
}

.menuArianeMastertag i {
	color: #fff;
	background-color: #23056b;
}

.menuArianeTrend {
	color: #23056b;
	border: 1px solid #23056b;
}

.menuArianeTrend i {
	color: #fff;
	background-color: #23056b;
}

.menuCategory {
	margin: 0px -20px 0px -20px;
	background-color: #fff;
	border-bottom: 1px solid #e5e5e5;
	overflow: auto;
	max-height: 339px;
}

.menuCategory.dynvibeClose {
	max-height: 0px;
	border-bottom: none;
}

.menuCategoryButton {
	background-color: #fff;
	margin: 0px -20px 25px -20px;
	padding: 3px 0px;
	border-bottom: 1px solid #e5e5e5;
	color: #7c7c7c;
	text-align: center;
}

.menuCategoryButton:hover {
	cursor: pointer;
	color: #33d1cd;
}

.titleH3 {
	font-size: 12px;
	font-weight: 700;
	color: #7c7c7c;
	text-align: center;
	text-transform: uppercase;
}

.menuCategory ul {
	list-style: none;
	padding: 0;
	font-size: 12px;
	font-weight: 700;
	color: #7c7c7c;
	max-height: 285px;
	overflow-y: auto;
}

.menuCategoryVal {
	display: block;
}

.menuCategoryPercent {
	display: block;
	margin-top: -3px;
	color: #c8c8c8;
}

.menuCategoryName {
	text-transform: uppercase;
}

.menuCategoryBar,
.menuCategoryBarComplete {
	border-radius: 3px;
	height: 5px;
}

.menuCategoryBar {
	width: 100%;
	margin-top: 3px;
	background-color: #c8c8c8;
}

.menuCategoryBarComplete {
	background-color: #a0a0a0;
}

.menuCategory > div {
	min-height: 338px;
}

.menuCategory ul li:hover {
	color: #33d1cd;
	cursor: pointer;
}

.menuCategory ul li:hover .menuCategoryPercent {
	color: #beeeec;
}

.menuCategory ul li:hover .menuCategoryBar {
	background-color: #beeeec;
}

.menuCategory ul li:hover .menuCategoryBarComplete {
	background-color: #33d1cd;
}

.menuCategory .categoryList ul .active {
	color: #ef402e;
}

.menuCategory .categoryList ul .active .menuCategoryPercent {
	color: #f7b1a9;
}

.menuCategory .categoryList ul .active .menuCategoryBar {
	background-color: #f7b1a9;
}

.menuCategory .categoryList ul .active .menuCategoryBarComplete {
	background-color: #ef402e;
}

.menuCategory .subcategoryList ul .active {
	color: #33d1cd;
}

.menuCategory .subcategoryList ul .active .menuCategoryPercent {
	color: #beeeec;
}

.menuCategory .subcategoryList ul .active .menuCategoryBar {
	background-color: #beeeec;
}

.menuCategory .subcategoryList ul .active .menuCategoryBarComplete {
	background-color: #33d1cd;
}

.menuCategory .mastertagList ul .active {
	color: #23056b;
}

.menuCategory .mastertagList ul .active .menuCategoryPercent {
	color: #b5abcc;
}

.menuCategory .mastertagList ul .active .menuCategoryBar {
	background-color: #b5abcc;
}

.menuCategory .mastertagList ul .active .menuCategoryBarComplete {
	background-color: #23056b;
}

.slide-enter-active {
	-moz-transition-duration: 0.5s;
	-webkit-transition-duration: 0.5s;
	-o-transition-duration: 0.5s;
	transition-duration: 0.5s;
	-moz-transition-timing-function: ease-in;
	-webkit-transition-timing-function: ease-in;
	-o-transition-timing-function: ease-in;
	transition-timing-function: ease-in;
}

.slide-leave-active {
	-moz-transition-duration: 0.5s;
	-webkit-transition-duration: 0.5s;
	-o-transition-duration: 0.5s;
	transition-duration: 0.5s;
	-moz-transition-timing-function: ease-in;
	-webkit-transition-timing-function: ease-in;
	-o-transition-timing-function: ease-in;
	transition-timing-function: ease-in;
}

.slide-enter-to,
.slide-leave {
	max-height: 339px;
	overflow: hidden;
}

.slide-enter,
.slide-leave-to {
	overflow: hidden;
	max-height: 0;
}
</style>
